import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=06f806f0&scoped=true"
var script = {}
import style0 from "./LayoutFooter.vue?vue&type=style&index=0&id=06f806f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f806f0",
  null
  
)

export default component.exports